export const PARTS = [
  { label: '全体', value: 'whole' },
  { label: '本体', value: 'mainUnit' },
  { label: 'ベロ表', value: 'tongueFront' },
  { label: 'つま先補強', value: 'toeReinforcement' },
  { label: '甲止め補強', value: 'vampStrapReinforcement' },
  { label: 'かかと補強', value: 'healReinforcement' },
  { label: 'サイド補強', value: 'sideReinforcement' },
  { label: '履き口補強', value: 'openingReinforcement' },
  { label: 'かかと飾り', value: 'healDecoration' }
]

export const MESH_PARTS = PARTS.filter((part) => !['mainUnit'].includes(part.value))
